// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../subHours/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var subHours = convertToFP(fn, 2);
export default subHours;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/subHours/index.js
// module id = 1003
// module chunks = 0